import LangSwitcher from './LangSwitcher'
import Icons from './Icons'
import React, { useState } from 'react'
import { CSSTransition } from 'react-transition-group'

const MobileNav = ({ currentSection }) => {
  const handleClick = (event, link) => {
    event.preventDefault()
    document.getElementById(link).scrollIntoView({ behavior: 'smooth', block: 'start' })
    toggleMenu()
  }


  const [mobileNav, showMobileNav] = useState(false)

  const toggleMenu = (event) => {
    if (event) event.preventDefault()
    showMobileNav(!mobileNav)
  }

  const menu = [
    {
      title: 'Home',
      icon: 'home',
      link: 'section1'
    },
    {
      title: 'About me',
      icon: 'user',
      link: 'section2'
    },
    {
      title: 'Services',
      icon: 'suitcase',
      link: 'section3'
    },
    {
      title: 'Experience',
      icon: 'graduation',
      link: 'section4'
    },
    {
      title: 'Clients and reviews',
      icon: 'speech-bubble',
      link: 'section5'
    },
    {
      title: 'Latest Posts',
      icon: 'notes',
      link: 'section6'
    },
    {
      title: 'Contact',
      icon: 'email',
      link: 'section7'
    }
  ]

  return <div className="relative">
    <a href="#" onClick={toggleMenu} className="fixed lg:hidden left-10 top-5 z-10">
      <Icons name="menu" className={`h-12 fill-current ${currentSection === 'section1' ? 'text-white' : 'text-martinique'}`}/>
    </a>
    <CSSTransition in={mobileNav} unmountOnExit timeout={200} classNames="mobile-menu"><nav className="block lg:hidden bg-martinique text-gray-400 border-r border-martinique-400 fixed w-full h-screen text-center justify-start content-start items-center z-30">
        <a href="#" onClick={toggleMenu} className="absolute right-12 top-5">
          <Icons name="close-button" className="h-8 fill-current text-white"/>
        </a>
    <div id="logo" className="justify-self-start w-full mt-12">
        <LangSwitcher className="mx-auto mt-10" />
    </div>
    <div id="menu" className="flex flex-col justify-start justify-self-center text-4xl font-bold mt-6">
      {menu.map((value, index) => {
        return <a key={index} className={`my-3 cursor-pointer ${currentSection === value.link ? 'text-yellow-400' : 'text-athens-gray-700 '}`} onClick={(e) => handleClick(e, value.link)}>
          {value.title}
        </a>
      })}
    </div>
    <div id="copy" className="justify-self-end w-full flex-1 relative text-sm">
      <p className="mt-10">&copy; 2022 Alexandre Lion.</p>
    </div>
  </nav></CSSTransition>
  </div>
}

export default MobileNav
